import styled from 'styled-components';

export const CommEarning = styled.div`
  background: ${p => (p.isLoading ? '#fff' : '#F9F9F9')};
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 24px;
  display: flex;
`;
export const CommEarningLft = styled.div`
  flex: 1;
`;
export const CommEarningRht = styled.div`
  min-width: 30%;
  padding-left: 22px;
  margin-left: 22px;
  border-left: 1px #dddddd solid;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  input {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    height: 40px;
    margin-bottom: 12px;
    padding: 0 8px;
  }
  p {
    font-size: 16px;
    line-height: 29px;
    color: #4a4a4e;
    font-weight: 800;
  }
`;
export const PrcBreakupDiv = styled.div`
  display: flex;
  gap: 3px;
  flex-direction: column;
`;
export const PrcDtl = styled.p`
  font-size: 12px;
  margin-bottom: 8px;
  span {
    font-weight: 700;
  }
`;
export const Info = styled.div`
  background-color: #ffedd1;
  padding: 4px;
  border-radius: 2px;
  font-size: 11px;
  line-height: 16px;
`;
export const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 22px;
`;
export const FormInputContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
export const LabelText = styled.p`
  font-size: 14px !important;
  line-height: 16px !important;
`;
export const InputBox = styled.input`
  margin-top: 8px !important;
`;
